import React from 'react';
import { MarketSvgProps } from '../market-icons';

const StepThree: React.FC<MarketSvgProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_1370_7106)">
        <path
          d="M12.1702 16.38C10.3702 16.38 8.99024 15.456 8.75024 13.704L10.7062 13.392C10.8022 14.244 11.3902 14.724 12.1342 14.724C12.8542 14.724 13.4062 14.352 13.4062 13.632C13.4062 12.924 12.8302 12.648 12.0142 12.648H11.2102V11.052H11.9902C12.7462 11.052 13.2382 10.764 13.2382 10.116C13.2382 9.528 12.8302 9.156 12.1462 9.156C11.4022 9.156 10.9222 9.696 10.8022 10.428L8.96624 10.212C9.17024 8.712 10.3462 7.5 12.2302 7.5C14.0542 7.5 15.1702 8.556 15.1702 9.984C15.1702 10.86 14.6542 11.556 14.0062 11.808C14.7742 12.108 15.3622 12.732 15.3622 13.8C15.3622 15.216 14.1262 16.38 12.1702 16.38Z"
          fill="#101010"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.92882 4.92846C8.83399 1.02329 15.1661 1.02343 19.0714 4.92846C22.9766 8.8337 22.9766 15.1658 19.0714 19.071C15.1662 22.9763 8.83406 22.9763 4.92882 19.071C1.0238 15.1658 1.02365 8.83362 4.92882 4.92846ZM17.6573 6.34252C14.5331 3.21854 9.467 3.2184 6.34288 6.34252C3.21876 9.46664 3.21891 14.5328 6.34288 17.657C9.46708 20.7812 14.5331 20.7812 17.6573 17.657C20.7815 14.5328 20.7815 9.46671 17.6573 6.34252Z"
          fill="#101010"
        />
      </g>
      <defs>
        <clipPath id="clip0_1370_7106">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepThree;
